import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {DataObjectId, SystemStickerType} from 'yougile-model'
import {AddUsersButton} from '@components/common/users-table/add-users-button'
import {UsersTable} from '@components/common/users-table/users-table'
import {StickerMenuHeader} from '@components/sticker/sticker-menu/sticker-menu-header'
import {
  useCanInvite,
  useIsOnBoard,
  useUsersList
} from '@components/sticker/sticker-menu/sticker-menu-user/hooks'
import {useStickerStore} from '@components/sticker/sticker-store'
import {PageService} from '@extensions/page-service'

export const StickerMenuUserPanel = observer(() => {
  const [state, store] = useStickerStore()
  const listUsers = useUsersList(store.stickerTask, store.sticker)
  const canInvite = useCanInvite()
  const isOnBoard = useIsOnBoard(store.sticker)
  const proj = PageService.getCurrentProject()

  return (
    <>
      <div className="sticker-item-list-head flex">
        <StickerMenuHeader
          stickerId={store.sticker.id}
          title={
            Lang.msg.stickerNames[
              store.stickerData.stickerType as SystemStickerType
            ]
          }
          onClickOnSettingHandler={store.closeStickerMenu}
        />
      </div>
      <div className="sticker-item-list-body bg-main-old mt-4 w-[304px]">
        <div className="h-[230px]">
          <UsersTable
            draggableUsers
            useCheckbox
            className="h-full"
            users={listUsers}
            selected={state.filterValues as DataObjectId[]}
            onDragStarted={store.startDragging}
            onDragStartedCallback={store.closeStickerMenu}
            onToggled={store.toggleFilter}
          />
        </div>
        {!isOnBoard && canInvite && (
          <div className="bg-main-old border-solid border-0 border-t border-main-old">
            <AddUsersButton onClick={store.closeStickerMenu} project={proj} />
          </div>
        )}
      </div>
    </>
  )
})
